import { render, staticRenderFns } from "./bottomFooter.vue?vue&type=template&id=79040beb&"
import script from "./bottomFooter.vue?vue&type=script&lang=js&"
export * from "./bottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./bottomFooter.vue?vue&type=style&index=0&id=79040beb&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports